import Layout from "@/components/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Users, Award, Clock, Shield, Target, Lightbulb, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
const Presentation = () => {
  const stats = [{
    number: "15+",
    label: "Années d'expérience"
  }, {
    number: "200+",
    label: "Projets réalisés"
  }, {
    number: "6/7",
    label: "Support technique"
  }, {
    number: "82%",
    label: "Clients satisfaits"
  }];
  const values = [{
    icon: Target,
    title: "Excellence Technique",
    description: "Nous utilisons les dernières technologies et respectons les normes les plus strictes pour garantir la qualité de nos installations."
  }, {
    icon: Users,
    title: "Service Client Personnalisé",
    description: "Chaque client est unique. Nous adaptons nos solutions à vos besoins spécifiques et vous accompagnons à chaque étape."
  }, {
    icon: Shield,
    title: "Sécurité & Fiabilité",
    description: "Nos installations respectent toutes les normes de sécurité. Nous garantissons la fiabilité et la durabilité de nos équipements."
  }, {
    icon: Lightbulb,
    title: "Innovation Continue",
    description: "Nous restons à la pointe de l'innovation pour vous proposer les solutions les plus avancées du marché."
  }];
  const expertise = [{
    domain: "Audiovisuel & Multimédia",
    description: "Conception et installation de systèmes audiovisuels complets pour entreprises, salles de spectacle et événements.",
    technologies: ["Systèmes de sonorisation professionnels", "Écrans LED et projecteurs 4K", "Régie audiovisuelle numérique", "Streaming et visioconférence"],
    images: ["/images/tempImagec0OT2l.jpg", "/images/salle_cinema_moderne_20251212_102940.png", "/images/tempImagevcWPsZ.jpg", "/images/tempImageN7vD7n.jpg", "/images/PHOTO-2021-04-27-19-07-27 2.jpg", "/images/tempImagexRDay2.jpg"]
  }, {
    domain: "Domotique & Automatisation",
    description: "Solutions intelligentes pour l'automatisation de vos espaces professionnels et résidentiels.",
    technologies: ["Contrôle d'éclairage intelligent", "Gestion de salle de conférence", "Sécurité intégrée", "Interface utilisateur intuitive"],
    images: ["/images/tempImageI4HtCZ.jpg", "/images/b907f38d-e21c-43e5-9ab7-a33a58e8b619.jpeg"]
  }, {
    domain: "Réseau & Télécommunications",
    description: "Infrastructure réseau robuste et maintenance de vos systèmes de télécommunications.",
    technologies: ["Installation matériel Swisscom/Salt/Sunrise", "Installation antenne satellite", "Installation fibre optique", "Réseaux sécurisés", "Diagnostic et dépannage", "Optimisation des performances"],
    images: ["/images/tempImageSJANF4.jpg", "/images/a73287c9-35c6-493b-b5cb-62ac611677e7.jpeg"]
  }, {
    domain: "Events & Service Location",
    description: "Location de matériel professionnel pour vos événements et manifestations.",
    technologies: ["Location sonorisation", "Location éclairage", "Matériel scénique", "Installation temporaire", "Support technique sur site"],
    images: ["/images/PHOTO-2022-02-07-15-39-41 2.jpg", "/images/IMG_1680.jpg"]
  }, {
    domain: "Machine à Café Professionnel",
    description: "Solutions complètes pour vos besoins en café professionnel, de la vente à la maintenance.",
    technologies: ["Maintenance machines à café", "Vente équipements professionnels", "Location machines", "Formation utilisateurs", "Contrats de maintenance"],
    images: ["/images/s-l1200.jpg", "/images/imagesSSDFG.jpeg"]
  }, {
    domain: "Traitement Acoustique",
    description: "Solutions acoustiques sur mesure pour améliorer la qualité sonore de vos espaces commerciaux et de divertissement.",
    technologies: ["Montage conseil sur mesure", "Plafond acoustique", "Paroi acoustique pour commerce", "Salle de cinéma", "Isolation phonique", "Étude acoustique"],
    images: ["/images/external-file_edited.png", "/images/assets_images_photo_file_34a04ee6-ecec-4bc0-9b40-bded744bd52c.jpeg"]
  }, {
    domain: "Sécurité & Surveillance",
    description: "Systèmes de vidéo surveillance et de sécurité adaptés à vos besoins de protection.",
    technologies: ["Caméras IP haute définition", "Enregistrement cloud sécurisé", "Surveillance mobile", "Détection intelligente"],
    images: ["/images/PHOTO-2021-12-16-20-09-44 2.jpg", "/images/PHOTO-2021-12-16-20-09-48 2.jpg"]
  }, {
    domain: "Réparation et Dépannage",
    description: "Services de réparation et dépannage pour tous vos équipements audiovisuels et techniques.",
    technologies: ["Dépannage équipements audiovisuels", "Réparation systèmes de sonorisation", "Maintenance préventive", "Diagnostic technique", "Réparation écrans et projecteurs", "Support technique d'urgence"],
    images: ["/images/tempImageJqe4p3.jpg", "/images/tempImageLSuZ65.jpg", "/images/tempImageAJCmO2.jpg"]
  }];
  return <Layout>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-background to-muted">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <Badge variant="outline" className="mb-4">
              À Propos de BT-Connect SARL
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold tracking-tight">
              Votre Partenaire Technologique de Confiance
            </h1>
            <div className="text-center space-y-6">
              <h2 className="text-2xl font-bold text-primary mb-4">Conseils - Planification - Offres sur mesure</h2>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Située en plein cœur de la Broye, nous sommes une entreprise familiale spécialisée dans l'audiovisuel.
              </p>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Nous opérons dans toute la Suisse romande et offrons des services de qualité pour répondre aux plus hautes exigences en termes de technicité, d'utilisation et d'esthétique.
              </p>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                L'entreprise BT-Connect met son savoir-faire à votre disposition afin de vous accompagner dans toutes les étapes de vos projets audiovisuels, de l'étude à l'intégration.
              </p>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Nous sommes également qualifiés pour prendre en charge la maintenance et le service de dépannage des installations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => <div key={index} className="text-center">
                <div className="text-3xl lg:text-4xl font-bold mb-2">{stat.number}</div>
                <div className="text-sm lg:text-base opacity-90">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Historique Section */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Historique
              </h2>
            </div>
            
            <div className="space-y-8">
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">1971</h3>
                <p className="text-muted-foreground leading-relaxed">
                  L'entreprise Radio TV-Brat, fondée à Lausanne par Monsieur Charles Brat, était un commerce spécialisé dans la réparation de radios et télévisions ainsi que les technologies antérieures.
                </p>
              </div>
              
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">2010</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Déjà à la tête de sa propre entreprise de sonorisation et d'éclairage, Fabien Brat, fils de Charles, reprend la direction de Radio TV-Brat.
                </p>
              </div>
              
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">2012</h3>
                <p className="text-muted-foreground leading-relaxed">
                  L'entreprise devenue familiale reprend la succession de Maendly Radio-TV à Yvonand. Dans le soucis de fournir un service de qualité à sa clientèle, le magasin réouvre ses portes. Le secteur d'activité s'étend alors dans le Nord-Vaudois et le Gros-de-Vaud.
                </p>
              </div>
              
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">2018</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Rachat de Radio-TV Bersier à Payerne. Un nouveau point de vente pour la Broye et alentours.
                </p>
              </div>
              
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">2019</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Reprise de l'entreprise Expert Rapin SA à Payerne afin de regrouper toutes les activités dans cette surface de vente.
                </p>
              </div>
              
              <div className="bg-background p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">2020</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Regroupement de toutes les activités sous l'enseigne Brat Image & Son. À Payerne et Yvonand, showroom et atelier de réparation, l'entreprise possède désormais deux enseignes pour vous satisfaire.
                </p>
              </div>
              
              <div className="bg-primary text-primary-foreground p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-bold mb-2">2025</h3>
                <p className="leading-relaxed">
                  En 2025, l'entreprise BT-Connect a été créée et a intégré les activités de Brat Image & Son SA pour être à l'écoute de ses clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Notre Mission
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Chez BT-Connect SARL, notre mission est de démocratiser l'accès aux technologies 
                avancées en proposant des solutions sur mesure, fiables et innovantes. Nous croyons 
                que chaque projet mérite une attention particulière et un service client exceptionnel.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {values.map((value, index) => <Card key={index} className="border-2 hover:border-primary/20 transition-all duration-300">
                  <CardHeader>
                    <div className="flex items-center space-x-3">
                      <div className="p-2 rounded-lg bg-primary/10">
                        <value.icon className="h-6 w-6 text-primary" />
                      </div>
                      <CardTitle className="text-xl">{value.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Nos Domaines d'Expertise
              </h2>
              <p className="text-lg text-muted-foreground">
                Une expertise technique reconnue dans tous les domaines de la technologie moderne
              </p>
            </div>

            <div className="space-y-8">
              {expertise.map((domain, index) => <Card key={index} className="overflow-hidden">
                  {domain.images && domain.images.length > 0 && <div className="aspect-video relative overflow-hidden">
                      <div className={`grid gap-1 h-full ${
                        domain.images.length === 1 ? 'grid-cols-1' :
                        domain.images.length === 2 ? 'grid-cols-2' :
                        'grid-cols-3'
                      }`}>
                        {domain.images.map((img, idx) => (
                          <img 
                            key={idx}
                            src={img} 
                            alt={`${domain.domain} - Image ${idx + 1}`}
                            className="w-full h-full object-cover"
                          />
                        ))}
                      </div>
                    </div>}
                  <CardHeader className="bg-gradient-to-r from-primary/5 to-primary/10">
                    <CardTitle className="text-2xl text-primary">{domain.domain}</CardTitle>
                    <CardDescription className="text-base">
                      {domain.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {domain.technologies.map((tech, idx) => <div key={idx} className="flex items-center space-x-2">
                          <div className="w-2 h-2 bg-primary rounded-full"></div>
                          <span className="text-sm">{tech}</span>
                        </div>)}
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Une Équipe d'Experts
            </h2>
            <p className="text-lg text-muted-foreground mb-12 leading-relaxed">
              Notre équipe est composée de techniciens certifiés et d'ingénieurs expérimentés, 
              passionnés par les nouvelles technologies. Nous nous formons continuellement pour 
              rester à la pointe de l'innovation et vous offrir les meilleures solutions.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <Award className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Certifications</h3>
                <p className="text-sm text-muted-foreground">
                  Techniciens certifiés par les plus grandes marques du secteur
                </p>
              </div>
              <div className="text-center">
                <Clock className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Réactivité</h3>
                <p className="text-sm text-muted-foreground">
                  Magasin: Mardi 9h-12h et 14h-17h, Jeudi 14h-17h. Lundi et Samedi matin sur RDV
                </p>
              </div>
              <div className="text-center">
                <Users className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Proximité</h3>
                <p className="text-sm text-muted-foreground">
                  Relation client personnalisée et suivi de projet dédié
                </p>
              </div>
            </div>

            <Button size="lg" asChild>
              <Link to="/contact">
                Rencontrer l'équipe
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </Layout>;
};
export default Presentation;